ProductController.$inject = ['$rootScope', 'ProductService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function ProductController($rootScope, ProductService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      ProductService.getProduct(profileId, $stateParams.slug).then(res => {
        vm.product = res.data
        copy = angular.copy(vm.product)
      })
    }
  })
  
  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.product.isPromoted = !vm.product.isPromoted
  }
  vm.setPublished = function() {
    vm.product.isPublished = !vm.product.isPublished
  }
  vm.addProductVariation = function() {
    vm.product.isFamily = true
    if (!vm.product.productVariations) vm.product.productVariations = new Array()
    vm.product.productVariations.push(ProductService.initProductVariation(vm.product))
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    ProductService.deleteProduct(vm.product).then(() => $state.go('shell.products'))
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.product, copy)) return ProductService.putProduct(vm.product)
  }, {invokeLimit: 1})
}